export { default } from './GlobalPopUps';



// WEBPACK FOOTER //
// ./src/components/Common/GlobalPopUps/index.js